import { useCallback, useRef } from "react";
import { useLocation } from "react-router-dom";

import { useWorkspace } from "src/contexts/global/WorkspaceContext";
import { useAllocationProject } from "src/contexts/global/GlobalContext";
import getTeamPath from "src/util/getTeamPath";

const useOnNodeSelected = ({ navigateTo, getTeamLinkTo }) => {
  const location = useLocation();
  const workspace = useWorkspace();
  const activeAllocationProject = useAllocationProject();
  const activeNodeHierarchyRef = useRef(null);

  return useCallback(
    (node) => {
      if (!node) {
        return;
      }

      const { group } = node;
      if (!group?.id) {
        return;
      }

      const pathname =
        getTeamLinkTo?.(node) ??
        getTeamPath({
          group,
          workspace,
          activeAllocationProject,
          pathname: location.pathname,
        });

      activeNodeHierarchyRef.current = group.hierarchyIds;
      navigateTo(pathname, group.hierarchyIds);
    },
    [
      activeAllocationProject,
      getTeamLinkTo,
      location.pathname,
      navigateTo,
      workspace,
    ]
  );
};

export default useOnNodeSelected;
